import React from 'react';

function formatCurrency(cents) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(cents || 0) / 100);
}

function PublicLineItems({items}) {
  return (
    <div className="line-items-preview">
      <div className="line-items-preview-head">
        <span>Item</span>
        <span>Qty / Days</span>
        <span>Unit Price</span>
        <span>Price</span>
      </div>
      {(items || []).map((item, index) => (
        <div className="line-items-preview-row" key={`${item.title}-${item.display_order ?? index}`}>
          <div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
          <span>{item.quantity}</span>
          <span>{formatCurrency(item.unit_price_cents)}</span>
          <strong>{formatCurrency(item.line_total_cents)}</strong>
        </div>
      ))}
    </div>
  );
}

export {formatCurrency};
export default PublicLineItems;